import { useEffect, useState } from "react";
import { Card } from "antd";
import {
  CheckCircleFilled,
  ExclamationCircleOutlined,
  PrinterOutlined,
  HomeOutlined,
} from "@ant-design/icons";
import { Button, Flex, Table, Modal } from "antd";
import {
  getNewData,
  getDataById,
  deleteData,
  addDataTigget,
  updateData,
  addData,
  sendRequest,
  addDataTiggetwithOutArg,
  collectFessmasterPayment as cacheKey,
} from "../../Api/api";
import "../../App.css";
import { useNavigate, useLocation } from "react-router-dom";
import useSWRMutation from "swr/mutation";
import { parsePaymentResponse } from "sabpaisa-pg-dev";
import { Alert, Spin } from "antd";

export default function SuccessPage() {
  const location = useLocation();
  const naviagate = useNavigate();

  const resutfromResponse = location?.state?.data;
  const [recipt_id, setReciptid] = useState("");
  const [isLoading, setisLoading] = useState(true);
  const params = new URLSearchParams(resutfromResponse);

  const [response, setResponse] = useState([]);

  const { trigger, data: newdatael } = useSWRMutation(
    "/student/studentAPP/PayOnline/collectFessmasterPayment",
    addDataTiggetwithOutArg
  );

  useEffect(() => {
    console.log("resutfromResponse", sessionStorage.getItem("SabPaisa"));
    const settings = JSON.parse(sessionStorage.getItem("SabPaisa"));
    const authKey = settings?.authKey ;
    const authIV =settings?.authIV ;


    const parseResponse = async () => {
      try {
        const data = await parsePaymentResponse(authKey, authIV);
        console.log("akuvkvdsgad__1_", data);
        setResponse(data);
        if (data?.status == "SUCCESS") {
          const body = {
            sabpaisaTxnId: data.sabpaisaTxnId,
            status: data.status,
            paymentMode: data.paymentMode,
            payMobile: data.payerMobile,
            paidAmount: data.paidAmount,
            clientTxnId: data.clientTxnId,
            amount: data.amount,
            session_id: JSON.parse(sessionStorage.getItem("Userdata"))
              ?.session_id,
          };
          console.log("data", body);
          // student/studentAPP/PayOnline/collectFessmasterPayment
          const result = await trigger(body);
          console.log("update_", result);
          if (result.Status == "Success") {
            setisLoading(false);
            setReciptid(result?.data);
          } else {
          }
        } else {
          setisLoading(false);
        }

        //console.log("akuvkvdsgad___",data && typeof data === 'object' ? Object.entries(data) : [])
      } catch (error) {
        console.error("Error parsing payment response:", error);
      }
    };
    parseResponse();
  }, []);


  const submitdata = async (e) => {
  
  };

  const viewDetails = async () => {
    //console.log("sssssssssssss", recipt_id);
    naviagate(`/FeeReciptPrint?receipt_id=${recipt_id}&type=feesmaster`);
  };

  const backHome = async () => {
    naviagate(`/`);
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      {!isLoading ? (
        <Card className="successCard">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              lineHeight: 3,
            }}
          >
            {response?.status == "SUCCESS" ? (
              <div style={{ marginBottom: 40, textAlign: "center" }}>
                <CheckCircleFilled style={{ color: "#32ba7c", fontSize: 50 }} />
                <div style={{ color: "#32ba7c", fontSize: 20 }}>
                  Payment Successful
                </div>
                <div>{response?.sabpaisaMessage}</div>
              </div>
            ) : (
              <div style={{ marginBottom: 40, textAlign: "center" }}>
                <ExclamationCircleOutlined
                  style={{ color: "#FF0000", fontSize: 50 }}
                />
                <div style={{ color: "#FF0000", fontSize: 20 }}>
                  Payment Failed!
                </div>
                {/* <div>{sabpaisaMessage}</div> */}
              </div>
            )}

            <div
              className="sdetails"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div>Payment type</div>
              <div style={{ fontWeight: "500" }}>{response?.paymentMode}</div>
            </div>
            <div
              className="sdetails"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div>Name</div>
              <div style={{ fontWeight: "500" }}>{response?.payerName}</div>
            </div>
            <div
              className="sdetails"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div>Mobile</div>
              <div style={{ fontWeight: "500" }}>{response?.payerMobile}</div>
            </div>

            <div
              className="sdetails"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div style={{ fontWeight: "bold", color: "#4f4f4f" }}>Amount</div>
              <div style={{ fontWeight: "bold", color: "#4f4f4f" }}>
                ₹{response?.amount}
              </div>
            </div>
            <div
              className="sdetails"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div style={{ fontWeight: "bold", color: "#4f4f4f" }}>
                Amount Paid
              </div>
              <div style={{ fontWeight: "bold", color: "#4f4f4f" }}>
                ₹{response?.paidAmount}
              </div>
            </div>
            <div
              className="sdetails"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div>Transaction Id</div>
              <div style={{ fontWeight: "500" }}>{response?.sabpaisaTxnId}</div>
            </div>
            <div
              className="sdetails"
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: "center",
                lineHeight: 2,
                width: "40%",
              }}
            >
              <Button
                style={{
                  padding: 5,
                  backgroundColor: "#0188cc",
                  color: "#fff",
                  fontWeight: "bold",
                  lineHeight: 1.5,
                  borderRadius: 5,
                }}
                onClick={(e) => backHome()}
              >
                Home
                <HomeOutlined
                  style={{ color: "#fff", cursor: "pointer", fontSize: 16 }}
                />
              </Button>
              {response?.status == "SUCCESS" ? (
                <Button
                  style={{
                    padding: 5,
                    backgroundColor: "#0188cc",
                    color: "#fff",
                    fontWeight: "bold",
                    lineHeight: 1.5,
                    borderRadius: 5,
                  }}
                  onClick={(e) => viewDetails()}
                >
                  Receipt
                  <PrinterOutlined
                    style={{ color: "#fff", cursor: "pointer", fontSize: 16 }}
                  />
                </Button>
              ) : null}
            </div>
          </div>
        </Card>
      ) : (
        <Spin tip="Loading" size="large">
          Loading..
        </Spin>
      )}
    </div>
  );
}
